"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CircleBgTopArrow = function CircleBgTopArrow(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#FFFFFF' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#FFFFFF' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.5001 3.16003C6.72467 3.16003 3.66409 6.22061 3.66409 9.99603C3.66409 13.7714 6.72467 16.832 10.5001 16.832C14.2755 16.832 17.3361 13.7714 17.3361 9.99603C17.3361 6.22061 14.2755 3.16003 10.5001 3.16003Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42412 9.48804C8.61612 9.68004 8.92412 9.68004 9.11212 9.48804L10.0121 8.58804L10.0121 13.184C10.0121 13.452 10.2321 13.672 10.5001 13.672C10.7681 13.672 10.9881 13.452 10.9881 13.184L10.9881 8.58804L11.8881 9.48804C12.0801 9.68004 12.3881 9.68004 12.5761 9.48804C12.7681 9.30004 12.7681 8.98804 12.5761 8.80004L10.8441 7.06804C10.7481 6.97204 10.6241 6.92404 10.5001 6.92404C10.3761 6.92404 10.2521 6.97204 10.1561 7.06804L8.42412 8.80004C8.23212 8.98804 8.23212 9.29604 8.42412 9.48804Z",
    fill: secondaryColor
  }));
};
var _default = exports["default"] = CircleBgTopArrow;